module.exports = __webpack_public_path__ + "static/img/kfwx.6423211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kfwx.jpg
// module id = r14k
// module chunks = 19